import React from 'react';
import {useRef} from 'react';
import * as api from '../../api';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ValidateEventDates } from '../../utils/ValidateEvent';
import Spinner from '../../Plateforme/Atoms/Spinner';
import CustomEditor from '../TextEditor/CustomEditor';

const FDEditEventAdminPanel = (props) => {

    const navigate = useNavigate();
    const [searchparams] = useSearchParams();
    const title_fr_ref = useRef(null);
    // const description_fr_ref = useRef(null);
    // const description_en_ref = useRef(null);
    const inscriptions_start_date_ref = useRef(null);
    const inscriptions_end_date_ref = useRef(null);
    const logo_path_ref = useRef(null);
    const image_path_ref = useRef(null);
    const [eventData, setEventData] = React.useState(null)

    const [descFR, setDescFR] = React.useState("")
    const [descEN, setDescEN] = React.useState("")

    React.useEffect(()=>{
        api.getEventById({id: searchparams.get("id")}).then((response) => {
            console.log(response.data)
            setEventData(response.data);

            setDescFR(response.data.description_fr)
            setDescEN(response.data.description_en)
        }).catch((error) => {
            console.log(error);
        });
    },[])

    async function handleUpdate() {
        console.log('trying to update');

        const newEvent = new FormData();
        newEvent.append("id", searchparams.get("id"));
        newEvent.append("title_fr", title_fr_ref.current.value);
        // newEvent.append("description_fr", description_fr_ref.current.value);
        // newEvent.append("description_en", description_en_ref.current.value);
        newEvent.append("description_fr", descFR);
        newEvent.append("description_en", descEN);
        newEvent.append("inscriptions_start_date", inscriptions_start_date_ref.current.value);
        newEvent.append("inscriptions_end_date", inscriptions_end_date_ref.current.value);
        newEvent.append("logo_path", logo_path_ref.current.files[0]);
        newEvent.append("image_path", image_path_ref.current.files[0]);

        if(!ValidateEventDates({type:eventData.type,inscriptions_start_date:inscriptions_start_date_ref.current.value,inscriptions_end_date:inscriptions_end_date_ref.current.value})){
            alert("Dates invalides")
            return
        }

        api.updateEvent(newEvent).then(res => {
            console.log(res);
            navigate("/admin/events")
        }).catch(err => {
            console.log(err);
            alert("erreur");
        });
    }

    async function handleDelete() {
        if(window.confirm("Supprimer définitivement l'évènement ?")){
            api.deleteEvent({id: searchparams.get("id")}).then(res => {
                console.log(res);
                navigate("/admin/events")
            });
        }
    }

    function invite_link(id, pop) {
        return "https://connectedby.lefrenchdesign.org/join?eid=" + id + "&pop=" + pop 
    }

    function copy_link(link){
        navigator.clipboard.writeText(link)
    }

    return (
        <div>
            {eventData ? <>
                <Link to="/admin/events"><button>← Retour aux événements</button></Link><br/><br/>
                <br/>
                <h1 className='centered'>Modifier l'évenement {eventData.title_fr}</h1>
                <h2><span >Type d'évènement : <strong>{eventData.type.toUpperCase()}</strong></span></h2><br/><br/>
                <div className='dualInput'>
                    <label>
                        Nom de l'appel à projet :<br/>
                        <input type="text" ref={title_fr_ref} defaultValue={eventData.title_fr}/>
                    </label>
                </div>
                Description FR :<br/><br/>
                <CustomEditor 
                    value={descFR}
                    onChange={setDescFR}
                />
                <br/><br/>
                Description EN :<br/><br/>
                <CustomEditor 
                    value={descEN}
                    onChange={setDescEN}
                />
                <br/><br/>
                <div className='dualInput'>
                    <label>
                        Date de début des inscriptions :<br/>
                        <input type="date" ref={inscriptions_start_date_ref} defaultValue={new Date(eventData.inscriptions_start_date).toISOString().split('T')[0]}/>
                    </label>
                    <label>
                        Date de fin des inscriptions :<br/>
                        <input type="date" ref={inscriptions_end_date_ref} defaultValue={new Date(eventData.inscriptions_end_date).toISOString().split('T')[0]}/>
                    </label>
                </div>
                <label>
                <h2> Logo :</h2><br/>
                    <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + eventData.logo_path}/>
                </label>
                <br/>
                <label>
                    Mettre à jour le logo :<br/>
                    <input type="file" ref={logo_path_ref} />
                </label>
                <br/>
                <label>
                    <h2>Visuel :</h2><br/>
                    <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + eventData.image_path}/>
                </label>
                <br/>
                <label>
                    Mettre à jour le visuel :<br/>
                    <input type="file" ref={image_path_ref} />
                </label>
                <br/>

                <div className='dualInput buttons_cont'>
                    <button className='dualbuttons' onClick={handleUpdate}>Enregistrer</button>
                    <button className='red_button dualbuttons' onClick={handleDelete}>Supprimer</button>
                </div>
                {/* <h2>Liens d'invitation</h2>
                <br/>
                <span className='thin'>Lien de l'évènement :</span><br/><br/>
                <div className='dualInput'>
                    <EventLink>{invite_link(eventData._id , "a")}</EventLink><button onClick={ () => copy_link(invite_link(eventData._id , "a"))}>Copier le lien</button>
                </div><br/><br/> */}
                <br/>
                <h2>Lien de prévisualisation :</h2>
                {/* in the form of http://localhost:3000/evenements/learnmore?eid=67590da5499bcc995c210b40 */}
                <br/>
                <Link to={"/evenements/learnmore?eid=" + eventData._id}><p>{"evenements/learnmore?eid=" + eventData._id}</p></Link>
                
            </>:<Spinner/>}
        </div>
    );
};

export default FDEditEventAdminPanel;